import React from 'react';
import { HashLink } from 'react-router-hash-link';
import { useCart } from "react-use-cart";


const NavLinks = () => {
    const { totalUniqueItems, metadata, updateCartMetadata } = useCart();
    
    return (
        <>
            <HashLink className="px-4 font-extrabold text-gray-500 hover:text-blue-900" smooth to="/#nosotros">
                Nosotros
            </HashLink>
            <HashLink className="px-4 font-extrabold text-gray-500 hover:text-blue-900" smooth to="/#servicios">
                Servicios
            </HashLink>
            {/* <HashLink className="px-4 font-extrabold text-gray-500 hover:text-blue-900" to="/">
                Clientes
            </HashLink> */}
            <HashLink className="px-4 font-extrabold text-gray-500 hover:text-blue-900" to="/#materiales">
                Materiales de Embalaje
            </HashLink>
            <HashLink className="px-4 font-extrabold text-gray-500 hover:text-blue-900" to="/contacto#contacto">
                Contáctanos
            </HashLink>
            <HashLink className="px-4 font-extrabold text-gray-500 hover:text-blue-900" to="/cotizacion#cotizacion">
                Cotización
            </HashLink>
            <HashLink onClick={() => (updateCartMetadata({open:!metadata.open}))} className=" text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl" smooth >
                Carro {totalUniqueItems>0?`(${totalUniqueItems})`:null}
                <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" id="Shopping-Cart--Streamline-Lucide" height="24" width="24">
                    <path d="M7 21a1 1 0 1 0 2 0 1 1 0 1 0 -2 0" stroke-width="2"></path>
                    <path d="M18 21a1 1 0 1 0 2 0 1 1 0 1 0 -2 0" stroke-width="2"></path>
                    <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95 -1.57l1.65 -7.43H5.12" stroke-width="2"></path>
                </svg>{' '}
            </HashLink>
        </>
    )
}

export default NavLinks;


